export const NEWBUILDING_CARD_PROFILE = 'newbuildingCard';
